module.exports = __webpack_public_path__ + "img/5.213bb0b9.svg";